import React, {Component} from 'react';
import {assignNested, deepCopyObject, showAxiosError} from "../../../helper/helper";
import {Col, Label, Row, UncontrolledTooltip} from 'reactstrap';
import 'react-datetime/css/react-datetime.css';
import 'moment/locale/tr';
import MiniButton from "../../../components/MiniButton";
import TextOverFlowTooltip from "../../../components/TextOverFlowTooltip";
import {request} from "../../../helper/APIUtils";
import Alert from "react-s-alert";
import moment from "moment";
import Datetime from "react-datetime";
import {validateField} from "../../../common/validation";
import XLSX from "xlsx";
import GetEnumDataAndValidation from "../../voucher/component/GetEnumDataAndValidation";
import {defaultInvoice, defaultRequestBank} from "../../voucher/helper/defaultData";
import ReactLoadingTop from "../../../components/ReactLoadingTop";

class AdditionalDocuments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            loading: false,
            loadingBank: false,
            requestBankData: [],
            errorBank: false,
            key: Math.random().toString(36),
            invoiceTypeCode: this.props.invoiceTypeCodes,
            invoiceToBank: false,
        };

        this.handleAdd = this.handleAdd.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
        this.addDocumentLine = this.addDocumentLine.bind(this);
        this.fileSelected = this.fileSelected.bind(this);
        this.bulkFileSelected = this.bulkFileSelected.bind(this);
        this.inputFile = React.createRef();
        this.inputFileBank = React.createRef();
        this.onChange = this.onChange.bind(this);
        this.validateField = this.validateField.bind(this);
        this.onChangeDate = this.onChangeDate.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.checkDateValidity = this.checkDateValidity.bind(this);
        this.removeAdditionalDocument = this.removeAdditionalDocument.bind(this);
        this.create_UUID = this.create_UUID.bind(this);
        this.invoiceToBankChange = this.invoiceToBankChange.bind(this);
        this.fileSelectedBank = this.fileSelectedBank.bind(this);
        this.invoiceToBankDocumentList = this.invoiceToBankDocumentList.bind(this);
        this.bulkFileSelectedBank = this.bulkFileSelectedBank.bind(this);
        this.addRequestBankLine = this.addRequestBankLine.bind(this);
        this.handleAddBank = this.handleAddBank.bind(this);
        this.addRequestLine = this.addRequestLine.bind(this);
        this.removeExcelDatas = this.removeExcelDatas.bind(this);
    }

    componentWillMount() {
        this.setState({additionalDocuments: this.props.additionalDocuments});
        this.setState({invoiceTypeCode: this.props.ivoiceTypeCodes});
        if (this.props.additionalDocuments.length > 0) {
            if (this.props.additionalDocuments[0].documentName === 'olay_numarasi') {
                this.setState({invoiceToBank: true});
                let excelDatas = [];
                for (let i = 0; i < this.props.additionalDocuments.length; i++) {
                    let doc = {
                        request_no: this.props.additionalDocuments[i].description,
                        // urun_hizmet: this.props.additionalDocuments[i].documentType,
                        // urun_id: this.props.additionalDocuments[i].contentType
                    }
                    excelDatas.push(doc);
                }
                this.setState({excelDatas: excelDatas});
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.error !== nextProps.error) {
            this.setState({error: nextProps.error});
        }
        if (nextProps.manual) {
            this.setState({additionalDocument: nextProps.additionalDocument, error: {}});
            this.props.isManual(false);
            this.props.errorListener({});
        }
    }

    handleAdd() {
        if (this.inputFile.current)
            this.inputFile.current.click();
    }

    handleAddBank() {
        if (this.inputFileBank.current)
            this.inputFileBank.current.click();
    }

    handleDownload(index) {
        let self = this;
        let additionalDocuments = deepCopyObject(this.state.additionalDocuments);
        let doc = additionalDocuments[index];
        let params = {
            url: `/invoiceTmp/downloadAttachment`,
            responseType: 'arraybuffer',
            method: "post",
            data: doc.recordId
        };
        request(params)
            .then(function (response) {
                let blob = new Blob([response.data], {type: response.headers["content-type"]});
                let urlCreator = window.URL || window.webkitURL;
                let url = urlCreator.createObjectURL(blob);

                let a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = doc.documentName;
                a.click();

            }).catch(function (error) {
            if (error.response === undefined) {
                showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
            } else {
                let enc = new TextDecoder("utf-8");
                showAxiosError({message: enc.decode(error.response.data)});
            }
        });
    }

    addRequestBankLine(excelDatas) {
        let additionalDocuments = [];
        if (excelDatas) {
            for (let i = 0; i < excelDatas.length; i++) {
                let doc = {
                    recordId: null,
                    invoiceId: null,
                    documentType: "request_no",//excelDatas[i].urun_hizmet,
                    documentId: this.create_UUID(),
                    issueDate: moment(),
                    description: excelDatas[i].request_no,
                    documentTypeCode: null,
                    contentType: null,//excelDatas[i].urun_id,
                    content: ' ',
                    documentName: "olay_numarasi",
                };
                additionalDocuments.push(doc);
            }
            this.props.listener(additionalDocuments);
        }
    }

    addDocumentLine() {
        let additionalDocuments = this.state.errorBank === false ? deepCopyObject(this.state.additionalDocuments) : [];
        if ((Array.isArray(additionalDocuments) && !additionalDocuments.length > 0) || additionalDocuments[0].documentType === null){
            this.setState({additionalDocuments: additionalDocuments, excelDatas: undefined})
        }
        if (additionalDocuments === null || additionalDocuments === undefined || (Array.isArray(additionalDocuments) && !additionalDocuments.length > 0)) {
            this.setState({additionalDocuments: additionalDocuments})
            let doc = {
                recordId: null,
                invoiceId: null,
                documentType: null,
                documentId: this.create_UUID(),
                issueDate: moment(),
                description: "",
                contentType: null,
                content: null,
                documentName: null
            };
            additionalDocuments = [doc];
        } else {
            let lastIndex = additionalDocuments.length;
            if (additionalDocuments[lastIndex - 1].documentName !== null)
                additionalDocuments.push({
                    recordId: null,
                    inoiceId: null,
                    documentType: null,
                    documentId: this.create_UUID(),
                    issueDate: moment(),
                    description: "",
                    contentType: null,
                    content: null,
                    documentName: null
                });
        }
        this.setState({additionalDocuments});
    }

    addRequestLine() {
        let excelDatas = deepCopyObject(this.state.excelDatas);
        if (excelDatas === null || excelDatas === undefined || (Array.isArray(excelDatas) && !excelDatas.length > 0)) {
            let doc = {
                request_no: null,
                // urun_hizmet: null,
                // urun_id: null
            };
            excelDatas.push(doc);
        } else {
            let lastIndex = excelDatas.length;
            if (excelDatas[lastIndex - 1].documentName !== null)
                excelDatas.push({
                    request_no: null,
                    // urun_hizmet: null,
                    // urun_id: null
                });
        }
        this.setState({excelDatas});
    }

    fileSelectedBank(event) {
        let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
        if (!!files) {
            if (files[0].name.endsWith(".xls") || files[0].name.endsWith(".xlsx") || files[0].name.endsWith(".XLS") || files[0].name.endsWith(".XLSX")) {
                let fileReader = new FileReader();
                fileReader.readAsArrayBuffer(files[0]);
                this.setState({processingExcel: true, uploadBtnDisabled: true, excelDatas: [], documentList: []});
                fileReader.onload = () => {
                    this.bulkFileSelectedBank(fileReader.result);
                };

                event.target.value = null;
            } else {
                Alert.closeAll();
                Alert.error('Dosya uzantısı yalnızca \'xlsx\' ya da \'xls\' olmalıdır.', {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }
        }
    }

    bulkFileSelectedBank(fileContent) {
        let invoiceBank = this.state.invoiceToBank;
        if (invoiceBank === true) {
            this.invoiceToBankDocumentList(fileContent)
        }
    }

    async invoiceToBankDocumentList(fileContent) {
        this.setState({loadingBank: true});
        this.props.loadingBank(this.state.loadingBank);
        let self = this;
        let workbook = XLSX.read(fileContent, {type: "array"});
        let sheet = workbook.Sheets[workbook.SheetNames[0]];
        let documentTmpList = {};
        let error = "";
        let invoiceEnum = [];
        let documentList = [];
        let excelDatas = [];
        let notes = [];
        try {
            if (sheet["!ref"] != null) {
                let range = XLSX.utils.decode_range(sheet["!ref"]);
                let sheetcopy = sheet;
                let rowLength = XLSX.utils.decode_range(sheet["!ref"]);
                invoiceEnum = GetEnumDataAndValidation.getExcelRequestBank(sheetcopy, rowLength);
                let headerControl = GetEnumDataAndValidation.getHeaderRequestBankValidation(invoiceEnum);
                for (let row = range.s.r; row <= range.e.r; row++) {
                    if (row > -1) {
                        let rowData = {};
                        if (((range.e.c + 1) >= rowLength.e.c) && headerControl) {
                            for (let col = range.s.c; col <= range.e.c; col++) {
                                let cell = sheet[XLSX.utils.encode_cell({r: row, c: col})];
                                if (invoiceEnum[col] === undefined) {
                                    break;
                                }

                                if (cell === undefined) {
                                    rowData[invoiceEnum[col][col]] = null;
                                    continue;
                                }
                                // if (invoiceEnum[col][col] === "urun_hizmet") {
                                //     rowData[invoiceEnum[col][col]] = cell.v;
                                // } else
                                    if (invoiceEnum[col][col] === "olay_numarasi") {
                                        rowData[invoiceEnum[col][col]] = cell.v;
                                    }
                                // } else if (invoiceEnum[col][col] === "urun_id") {
                                //     rowData[invoiceEnum[col][col]] = cell.v;
                                // }
                            }
                            let controlObject = 1;
                            let invoiceValidation = GetEnumDataAndValidation.requestBankValidation(rowData, row, controlObject);
                            controlObject = invoiceValidation.controlObject;
                            error = error + invoiceValidation.error;
                            rowData = GetEnumDataAndValidation.setNameRequestBank(rowData, controlObject, row);
                            if (rowData && Object.keys(rowData).length <= rowLength.e.c + 1 && controlObject) {
                                if (rowData["olay_numarasi"] in documentTmpList) {
                                    documentTmpList[rowData["olay_numarasi"]].push(rowData);
                                } else {
                                    documentTmpList[rowData["olay_numarasi"]] = {rowData}
                                }
                            }
                        }
                    }
                }
                if (!headerControl) {
                    error = error + " <strong> Doküman içerisinde zorunlu başlık alanları hatalı. Dokümanı kontrol ediniz.</strong><br/>";
                } else {
                    for (let key in documentTmpList) {
                        documentList.push(defaultRequestBank(documentTmpList[key], this.state.exemptions));
                        let documentTmp = documentTmpList[key];
                        excelDatas.push({
                            // urun_hizmet: documentTmp["rowData"]["urun_hizmet"],
                            request_no: documentTmp["rowData"]["olay_numarasi"],
                            // urun_id: documentTmp["rowData"]["urun_id"]
                        });
                    }
                }
            } else {
                error = error + " <strong> Boş bir doküman yüklediniz.</strong><br/>";
            }
            for (let i = 0; i < excelDatas.length; i++){
                if (excelDatas[i].request_no === "olay_numarasi"){
                    excelDatas.splice(i, 1);
                }
            }
            self.setState({excelDatas: excelDatas})
            self.setState({requestBankData: excelDatas})
            this.addRequestBankLine(excelDatas);
            this.setState({loadingBank: false})
            this.props.loadingBank(this.state.loadingBank);
            if (error) {
                Alert.closeAll();
                Alert.info(error, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 8000
                });
                this.setState({errorBank: true})
                this.removeExcelDatas();
            } else {
                this.setState({errorBank: false})
            }
        } catch (err) {
            if (err) {
                Alert.closeAll();
                Alert.info(err + '. Dokümanı kontrol ediniz.', {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 8000
                });
                this.setState({loadingBank: false})
                this.props.loadingBank(this.state.loadingBank);
            }
        }
    }

    fileSelected(event, index) {
        let self = this;
        let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
        if (!!files) {
            self.setState({loading: true});
            let fileReader = new FileReader();
            fileReader.readAsArrayBuffer(files[0]);
            let content = files[0];
            let fileType = files[0].type;
            let fileName = files[0].name;
            if (fileType === null || fileType === undefined || fileType === "") {
                Alert.error("Seçtiğiniz dosya yapısı desteklenmemektedir.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
                self.setState({loading: false});
            } else {
                fileReader.onload = () => {
                    self.bulkFileSelected(content, fileType, fileName, index);
                };
            }
            event.target.value = null;
        }
    }

    bulkFileSelected(filecontent, contentType, documentName, index) {
        let self = this;
        let formData = new FormData();
        formData.append("filename", documentName);
        formData.append("content", filecontent);
        let params = {
            url: "/invoiceTmp/uploadAttachment",
            method: "post",
            data: formData
        };
        request(params)
            .then(response => {
                let contentPath = response.data;
                let additionalDocuments = deepCopyObject(self.state.additionalDocuments);
                additionalDocuments[index]["contentType"] = contentType;
                additionalDocuments[index]["documentType"] = null;
                additionalDocuments[index]["documentName"] = documentName;
                additionalDocuments[index]["content"] = contentPath;
                this.setState({additionalDocuments, loading: false});
                self.state.additionalDocuments = additionalDocuments;
                this.props.listener(self.state.additionalDocuments);
            }).catch(function (error) {
            self.setState({loading: false});
            showAxiosError(error);
        });
    }

    onChange(e, index) {
        let name = e.target.name;
        let value = e.target.value;
        let additionalDocuments = deepCopyObject(this.state.additionalDocuments);
        if (name === "description") {
            additionalDocuments[index]['description'] = value;
        } else if (name === "DocumentId") {
            additionalDocuments[index]['documentId'] = value;
        }

        this.state.additionalDocuments = additionalDocuments;
        this.props.listener(this.state.additionalDocuments);
    }

    validateField(e, custom) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = !!custom ? custom : validateField(rule, boundary, e.target.value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    onChangeDate(e, type, fullFieldName, index) {
        let value = e;
        let additionalDocuments = deepCopyObject(this.state.additionalDocuments);

        if (!(typeof value === "string")) {
            if (type === "datetime") {
                if (assignNested(additionalDocuments[index], fullFieldName, value.format("YYYY-MM-DDTHH:mm:ss"))) {
                    this.setState({additionalDocuments})
                }
            }
        } else {
            if (type === "datetime") {
                if (assignNested(additionalDocuments[index], fullFieldName, value)) {
                    this.setState({additionalDocuments})
                }
            }
        }
        this.state.additionalDocuments = additionalDocuments;
        this.props.listener(this.state.additionalDocuments);
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    checkDateValidity(current, name) {
        let start = Datetime.moment().subtract(0, 'day');

        if (name === 'issueDate') {
            return current.isBefore(start);
        }
    }

    async dowloadExcel(){
        let data = [];

        data.push({
            // urun_hizmet: "urun_hizmet",
            // urun_id: "urun_id",
            olay_numarasi: "olay_numarasi",
        });

        // data[0]["urun_hizmet"] = "urun_hizmet";
        // data[0]["urun_id"] = "urun_id";
        data[0]["olay_numarasi"] = "olay_numarasi";

        let row = {
            // urun_hizmet: "Poliçe",
            // urun_id: "123",
            olay_numarasi: "123456789"
        };

        data.push(row);

        let ws = XLSX.utils.json_to_sheet(data, {skipHeader: true});
        let wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Şablon");
        XLSX.writeFile(wb, "olay_numarasi" + moment().format("YYYY_mm_dd_HH_mm_ss") + ".xlsx");
    }

    removeAdditionalDocument(index) {
        let additionalDocuments = deepCopyObject(this.state.additionalDocuments);
        additionalDocuments.splice(index, 1);
        this.setState({additionalDocuments: additionalDocuments});
        this.props.listener(additionalDocuments);
    }

    removeExcelDatas() {
        let excelDatas = this.state.excelDatas;
        let additionalDocuments = this.state.additionalDocuments;
        if (excelDatas !== undefined && excelDatas.length > 0) {
            excelDatas.splice(0, excelDatas.length);
            additionalDocuments.splice(0, additionalDocuments.length);
            excelDatas = undefined;
            this.setState({excelDatas: excelDatas, additionalDocuments: additionalDocuments});
            this.addRequestBankLine(excelDatas);
        }
    }

    invoiceToBankChange() {
        if (this.state.invoiceToBank === false) {
            this.setState({invoiceToBank: true})
        } else {
            this.setState({invoiceToBank: false})
        }
    }

    create_UUID() {
        let dt = new Date().getTime();
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    }

    render() {
        let additionalDocuments = deepCopyObject(this.state.additionalDocuments);
        return (
                <Row>
                    <Col sm="12">
                        <div key={this.state.key}>
                            <div className="card-body">
                                <Row>
                                    <Col sm="12" style={{
                                        paddingRight: '5px',
                                        paddingLeft: '5px',
                                        width: 'auto',
                                        maxHeight: '200px',
                                        overflow: "auto"
                                    }}>
                                        <table className=""
                                               style={{textAlign: 'center', paddingBottom: "5px", overflow: "scroll"}}>
                                            <thead>
                                            <tr style={{backgroundColor: '#ebedf0'}}>
                                                <th>#</th>
                                                {(!this.state.invoiceToBank) && <th>Doküman Adı</th>}
                                                {this.props.invoiceTypeCodes === "MATBUDAN" &&
                                                    <th>Doküman No(Seri-Sıra No)</th>}
                                                {this.props.invoiceTypeCodes === "MATBUDAN" && <th>Tarih</th>}
                                                {this.props.invoiceTypeCodes === "MATBUDAN" && <th>Açıklama</th>}
                                                {/*{this.state.invoiceToBank === true && <th>Ürün / Hizmet</th>}*/}
                                                {/*{this.state.invoiceToBank === true && <th>Ürün ID</th>}*/}
                                                {this.state.invoiceToBank === true && <th>Olay Numarası</th>}
                                                {((this.state.invoiceToBank === false || this.state.excelDatas === undefined)) && <th>İşlemler</th>}
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {!this.state.excelDatas && additionalDocuments && additionalDocuments.map((additionalDocument, index) =>
                                                <tr>
                                                    <td style={{margin: "0px"}}>{(index + 1)}</td>
                                                    {!this.state.loading && (!this.state.invoiceToBank) &&
                                                        <td style={{margin: "0px"}}>
                                                            {additionalDocument.documentName}
                                                        </td>}


                                                    {this.state.loading &&
                                                        <td style={{margin: "0px"}}>{<TextOverFlowTooltip
                                                            text="Doküman İşleniyor..."
                                                            maxLength={40}/>}</td>}
                                                    {this.props.invoiceTypeCodes === "MATBUDAN" &&
                                                        <td style={{margin: "0px"}}>
                                                            <input
                                                                type="text"
                                                                id="DocumentId"
                                                                value={this.state.documentId}
                                                                onChange={(e) => this.onChange(e, index)}
                                                                name="DocumentId"/>
                                                        </td>}
                                                    {this.props.invoiceTypeCodes === "MATBUDAN" &&
                                                        <td style={{margin: "0px"}}>
                                                            <div
                                                                className={"form-group" + this.validateClass('issueDate')}>
                                                                <Datetime locale="tr"
                                                                          className=""
                                                                          input={true}
                                                                          onBlur={(momentObj) => this.validateField({
                                                                              target: {
                                                                                  id: "issueDate",
                                                                                  dataset: {'vdata': "datetime"},
                                                                                  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY HH:mm:ss") : momentObj)
                                                                              }
                                                                          })}
                                                                          inputProps={{id: 'issueDate'}}
                                                                          closeOnSelect={false}
                                                                          closeOnTab={false}
                                                                          value={moment(this.state.additionalDocuments.issueDate, "YYYY-MM-DDTHH:mm:ss", true).isValid() ?
                                                                              moment(this.state.additionalDocuments.issueDate).format("DD-MM-YYYY HH:mm:ss") :
                                                                              this.state.additionalDocuments.issueDate}
                                                                          dateFormat="DD-MM-YYYY"
                                                                          timeFormat="HH:mm:ss"
                                                                          isValidDate={function (current) {
                                                                              return current.isBefore(Datetime.moment());
                                                                          }}
                                                                          onChange={(e) => this.onChangeDate(e, "datetime", "issueDate", index)}/>
                                                                {this.validateMessage('issueDate') !== "" &&
                                                                    <UncontrolledTooltip
                                                                        placement="right"
                                                                        target="issueDate"
                                                                        delay={0}>
                                                                        {this.validateMessage("issueDate")}
                                                                    </UncontrolledTooltip>}
                                                            </div>
                                                        </td>}
                                                    {this.props.invoiceTypeCodes === "MATBUDAN" &&
                                                        <td style={{margin: "0px"}}>
                                                            <input
                                                                type="text"
                                                                id="description"
                                                                value={this.state.description}
                                                                onChange={(e) => this.onChange(e, index)}
                                                                name="description"/>
                                                        </td>}
                                                    {this.state.invoiceToBank === true &&
                                                        <td style={{margin: "0px"}}>
                                                            <input ref={this.inputFileBank}
                                                                   type="file" accept=".xlsx,.xls,.XLS,.XLSX"
                                                                   multiple={false}
                                                                   style={{
                                                                       display: 'block',
                                                                       visibility: 'hidden',
                                                                       width: '0px',
                                                                       height: '0px'
                                                                   }}
                                                                   onChange={this.fileSelectedBank}
                                                            />
                                                        </td>}
                                                    {/*{this.state.invoiceToBank === true &&*/}
                                                    {/*    <td style={{margin: "0px"}}>*/}
                                                    {/*    </td>}*/}
                                                    {/*{this.state.invoiceToBank === true &&*/}
                                                    {/*    <td style={{margin: "0px"}}>*/}
                                                    {/*    </td>}*/}
                                                    {<td style={{margin: "0px"}}>
                                                        {<div>
                                                        <input ref={this.inputFile}
                                                               type="file" multiple={false}
                                                               style={{
                                                                   display: 'block',
                                                                   visibility: 'hidden',
                                                                   width: '0px',
                                                                   height: '0px'
                                                               }}
                                                               onChange={(e) => this.fileSelected(e, index)}/>
                                                        {!additionalDocument.recordId &&
                                                            <MiniButton title="Doküman Ekle" faIcon="fa fa-plus"
                                                                        onClick={this.state.invoiceToBank === false ? () => this.handleAdd() : () => this.inputFileBank && this.inputFileBank.current && this.inputFileBank.current.click()}
                                                                        color="success"/>}
                                                        {additionalDocument.recordId && additionalDocument.recordId > 0 &&
                                                            <MiniButton title="İndir" faIcon="fas fa-download"
                                                                        color="warning"
                                                                        onClick={() => this.handleDownload(index)}/>}
                                                        <MiniButton title="Satırı Sil" faIcon="fa-minus" color="warning"
                                                                    onClick={() => this.removeAdditionalDocument(index)}/>
                                                    </div>}
                                                    </td>}

                                                </tr>
                                            )}
                                            {this.state.excelDatas && this.state.excelDatas.map((additionalDocument, index) =>
                                                <tr>
                                                    <td style={{margin: "0px"}}>{(index + 1)}</td>
                                                    {/*{this.state.invoiceToBank === true &&*/}
                                                    {/*    <td style={{margin: "0px"}}>*/}
                                                    {/*        {additionalDocument.urun_hizmet}*/}
                                                    {/*    </td>}*/}
                                                    {/*{this.state.invoiceToBank === true &&*/}
                                                    {/*    <td style={{margin: "0px"}}>*/}
                                                    {/*        {additionalDocument.urun_id}*/}
                                                    {/*    </td>}*/}
                                                    {this.state.invoiceToBank === true &&
                                                        <td style={{margin: "0px"}}>
                                                            {additionalDocument.request_no}
                                                        </td>}
                                                </tr>
                                            )}
                                            </tbody>
                                        </table>
                                    </Col>
                                </Row>
                            </div>
                            {
                                <div className="col-sm-12">
                                <Label>
                                    <input type="checkbox"
                                           checked={this.state.invoiceToBank}
                                           onChange={this.invoiceToBankChange}
                                           disabled={this.state.excelDatas !== undefined && this.state.excelDatas.length > 0}
                                    />
                                    Fatura Bankaya Kesilecek.
                                </Label>
                            </div>}
                            <div className="col-sm-12">
                                <button type="button"
                                        className="TekBtn ekle hizala  btn-md"
                                        style={{float: 'right', marginBottom: '5px'}}
                                        disabled={this.state.loading || this.state.loadingBank || (this.state.excelDatas !== undefined && this.state.excelDatas.length > 0)}
                                        onClick={this.addDocumentLine}>Satır Ekle
                                </button>
                                { this.state.excelDatas !== undefined &&
                                    <button type="button"
                                            className="TekBtn ekle hizala  btn-md"
                                            style={{float: 'right', marginRight: '5px'}}
                                            disabled={this.state.loading || this.state.loadingBank}
                                            onClick={this.removeExcelDatas}>VERİLERİ SİL
                                    </button>
                                }
                                { this.state.invoiceToBank === true &&
                                    <button type="button"
                                            className="TekBtn ekle hizala  btn-md"
                                            style={{float: 'right', marginRight: '5px'}}
                                            disabled={this.state.loading || this.state.loadingBank}
                                            onClick={this.dowloadExcel}>Örnek Excel İNDİR
                                    </button>
                                }
                            </div>
                        </div>
                    </Col>
                </Row>
        );
    }
}

export default AdditionalDocuments;